<template>
  <div>
    <Row>
      <Col span="22">
        <div class="container_wang_changPayPassword">
          <Form ref="formCustom" :model="formCustom" :rules="ruleCustom">
            <table>
              <tr>
                <td class="title" colspan="2">支付密码修改</td>
              </tr>
              <tr>
                <td>原密码</td>
                <td>
                  <FormItem prop="password">
                    <Input type="password" v-model="formCustom.password" :maxlength="6"/>
                  </FormItem>
                </td>
              </tr>

              <tr>
                <td>新密码</td>
                <td>
                  <FormItem prop="passwordNew">
                    <Input type="password" v-model="formCustom.passwordNew" :maxlength="6"/>
                  </FormItem>
                </td>
              </tr>
              <tr>
                <td>再次输入新密码</td>
                <td>
                  <FormItem prop="passwordCheck">
                    <Input type="password" v-model="formCustom.passwordCheck" :maxlength="6"/>
                  </FormItem>
                </td>
              </tr>
              <tr>
                <td>手机号</td>
                <td>{{phone}}</td>
              </tr>
              <tr>
                <td>验证码</td>
                <td class="authcode">
                  <FormItem class="new" prop="captcha">
                    <Input v-model="formCustom.captcha "/>
                    <div class="captchaBox" @click="getCode">
                      <span v-if="!show">获取验证码</span>
                      <span v-if="show">{{count}}</span>
                    </div>
                  </FormItem>
                </td>
              </tr>
            </table>
          </Form>
          <my-button @confirm="submit">确定</my-button>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'


  export default {
    name: "changePayPassword",
    components: {
      MyButton,
    },
    data() {
      const password = (rule, value, callback) => {
        let reg = /^\d{6}$/;
        let res = reg.test(value);
        if (value === '') {
          return callback(new Error('原密码不能为空'));
        } else {
          if (!res) {
            callback(new Error('请输入6位数字密码'));
          }
        }
        callback();
      };
      const passwordNew = (rule, value, callback) => {
        let reg = /^\d{6}$/;
        let res = reg.test(value);
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (!res) {
            callback(new Error('请输入6位数字密码'));
          } else {
            if (this.formCustom.passwordCheck !== '') {
              // 对第二个密码框单独验证
              this.$refs.formCustom.validateField('passwordCheck');
            }
          }
          callback();
        }
      };
      const validatePassCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formCustom.passwordNew) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      const validateAuthcode = (rule, value, callback) => {
        if (value === '') {
          return callback(new Error('验证码不能为空'));
        } else {
          callback();
        }
      };
      return {
        show: false,
        count: 0,
        phone: '',
        timer: null,
        formCustom: {
          password: '',
          passwordNew: '',
          passwordCheck:'',
          captcha: '',
          checkId:'',
          checkIdNew:'',
          realName:''
        },
        ruleCustom: {
          password: [
            {validator: password, trigger: 'blur'}
          ],
          passwordNew: [
            {validator: passwordNew, trigger: 'blur'}
          ],
          passwordCheck: [
            {validator: validatePassCheck, trigger: 'blur'}
          ],
          captcha: [
            {validator: validateAuthcode, trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {
      this.phone = JSON.parse(window.sessionStorage.getItem('userName'))
      ApiClient.get('/desktop/profile/identification.do').then(data => {
        this.formCustom = Object.assign({}, this.formCustom, data);
        this.formCustom.realName = this.formCustom.realName;
        if (this.formCustom.checkId === null && this.formCustom.stateNew === null) {
          this.formCustom.state = '未认证';
          this.$Message.error('请先完善认证,才能修改支付密码');
          this.$router.push({name:'authIndex'})
        }
        if (this.formCustom.checkId !== null && this.formCustom.stateNew === '处理中'){
          this.formCustom.state = '已认证（认证修改审核中）';
        }
        if (this.formCustom.checkId !== null && this.formCustom.stateNew === null){
          this.formCustom.state = '已认证';
          this.$router.push({name:'changePayPassword'})
        }
        if (this.formCustom.checkId === null && this.formCustom.stateNew === '失败') {
          ApiClient.get('/desktop/profile/identificationFail.do', {
            id: this.formCustom.checkIdNew
          }).then(data => {

          })
        }
      });
    },
    methods: {
      submit() {
        this.$refs.formCustom.validate((valid) => {
          if (valid) {
            ApiClient.put('/desktop/customer/updateCashPassword.do', this.formCustom,{silent: true}).then(data => {
              this.formCustom={
                password: '',
                passwordNew: '',
                passwordCheck:'',
                captcha: '',
              };
              this.$Message.success("修改成功");
              this.$router.push({name:'index'})
            }).catch(data=>{
              this.formCustom={
                password: '',
                passwordNew: '',
                passwordCheck:'',
                captcha: '',
              };
              this.$Message.error(data.message);
            })
          }
        })
      },
      getCode() {
        if (this.count === 0) {
          ApiClient.post('/commons/captcha/getCaptcha.do', {
            mobile:this.phone,
            type:'change_cash_password',
          }, {silent: true}, true).then(data => {
          }).catch(data => {
            this.$Message.error(data.message)
          });
          const TIME_COUNT = 60;
          if (this.timer === null) {
            this.count = TIME_COUNT;
            this.show = true;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = false;
                clearInterval(this.timer);
                this.timer = null
              }
            }, 1000)
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '~@/app.less';

  .title {
    font-size: @small-f;
    font-weight: 700;
  }

  table {
    border-collapse: collapse;
    margin-left: 60px;
    margin-top: 16px;
    width: 100%;
    tr td {
      border: 1px solid #D8D8D8;
      height: 42px;
      padding-left: 20px;
    }
    tr td:nth-child(2n+1) {
      width: 17%;
    }
    tr td:nth-child(2n) {
      width: 57%;
    }
  }

  table tr:nth-child(1), table tr:nth-child(3), table tr:nth-child(5), table tr:nth-child(7) {
    background-color: #F6F6F5;
  }

  .captchaBox {
    cursor: pointer;
    position: absolute;
    left: 38.5%;
    top: 0;
    width: 10%;
    height: 32px;
    color: @theme-c;
    border: 1px solid @theme-c;
    border-radius: 4px;
    line-height: 32px;
    margin-left: 0.6%;
    text-align: center;
  }
</style>

<style>
  .container_wang_changPayPassword .ivu-input {
    width: 50%;
    margin-left: -10px;
  }

  .container_wang_changPayPassword button {
    margin-left: 46%;
    margin-top: 60px;
  }

  .container_wang_changPayPassword .ivu-form-item {
    margin-bottom: 0;
  }

  .container_wang_changPayPassword .ivu-form-inline .ivu-form-item {
    width: 100%;
  }

  .container_wang_changPayPassword .ivu-form-item-error-tip {
    display: inline;
    position: static;
  }

  .container_wang_changPayPassword .ivu-input-wrapper {
    width: auto;
    display: inline;
  }

  .container_wang_changPayPassword .new .ivu-input {
    width: 39%;
    margin-left: -10px;
  }

  .container_wang_changPayPassword .authcode .ivu-form-item-error-tip {
    position: absolute;
    left: 50%;
    top: 15%
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/changePayPassword.vue